export const CONTRACT_STATUSES = [
  "PROPOSTA",
  "DOCUMENTACAO",
  "ASSINADO",
  "ENTRADA_EM_RECEBIMENTO",
  "ENTRADA_QUITADA",
  "ENGENHARIA",
  "PREFEITURA",
  "CAIXA",
  "OBRA_EM_EXECUCAO",
  "OBRA_CONCLUIDA",
  "HABITE_SE",
  "ENTREGUE",
  "ENCERRADO",
  "CANCELADO"
] as const;

export const ACTIVE_CONTRACT_STATUSES = CONTRACT_STATUSES.filter(
  (status) => !["PROPOSTA", "ENCERRADO", "CANCELADO"].includes(status)
);

export const CONTRACT_MODALITIES = [
  "TERRENO_CONSTRUCAO",
  "CONSTRUCAO_TERRENO_PROPRIO",
  "CONSTRUCAO_TERRENO_CONSTRUTORA",
  "SERVICO_ENGENHARIA"
] as const;

export const CONTRACT_MODALITY_LABELS: Record<(typeof CONTRACT_MODALITIES)[number], string> = {
  TERRENO_CONSTRUCAO: "Terreno + Construção",
  CONSTRUCAO_TERRENO_PROPRIO: "Construção em Terreno Próprio",
  CONSTRUCAO_TERRENO_CONSTRUTORA: "Construção em Terreno da Construtora",
  SERVICO_ENGENHARIA: "Serviço de Engenharia"
};

export type ContractStatus = (typeof CONTRACT_STATUSES)[number];
export type ContractModality = (typeof CONTRACT_MODALITIES)[number];
